export default __webpack_public_path__ + "static/media/ce-rosetta-lp.8ada1980.png";